const de = {
  // Generic
  Name: 'Name',
  Cancel: 'Abbrechen',
  'Add Pipeline': 'Neue Pipeline anlegen',
  Pipeline: 'Pipeline',
  Import: 'Importieren',
  Pipelines: 'Pipelines',
  Error: 'Fehler',
  Loading: 'Lädt',
  Algorithms: 'Algorithmen',
  // Assignments: 'Aufgaben',
  'Assignments': 'Aufgaben',
  Results: 'Ergebnisse',
  Homepage: 'Startseite',
  No: 'Nein',
  Center: 'Zentrieren',
  Add: 'Hinzufügen',
  'Delete (Del.)': 'Entfernen (Entf.)',
  Edit: 'Bearbeiten',
  Yes: 'Ja',
  Edge: 'Kante',
  'Error getting pipelines': 'Fehler beim Abruf der Pipelines',
  'Error getting results': 'Fehler beim Abruf der Ergebnisse',
  'Error fetching pipelines': 'Fehler beim Abruf der Pipelines',
  'An unexpected Error has occurred': 'Es ist ein unerwarteter Fehler aufgetreten.',
  'undo': 'Rückgängig',

  // Assignments.tsx etc
  'Due in': 'Fällig in',
  'Due Date': 'Fällig am',
  'Score': 'Punktzahl',

  // ResultsPipelineOverview.tsx
  'Result ID': 'Ergebnis ID',
  'Preview': 'Vorschau',


  // CreatePipelineDialog.tsx
  'Please check your input!': 'Bitte Angaben überprüfen!',
  'Error creating pipeline:': 'Fehler beim erstellen der Pipeline:',
  Create: 'Neu erstellen',
  Importieren: 'Importieren',
  Copy: 'Kopieren',
  'Create pipeline': 'Pipeline erstellen',
  // formProcessingService.ts
  'Not Authenticated': 'Nicht angemeldet',
  'No file given': 'Keine Datei angegeben',
  'Pipeline not available': 'Pipeline nicht verfügbar',
  'Should not happen': 'Sollte nicht passieren',
  // ImportPipeline.tsx
  'Upload File': 'Datei hochladen',
  Filename: 'Dateiname',
  // AppBreadcrumb.tsx
  Home: 'Home',
  // Footer.tsx
  'Laboratory for Machine Tools and Production Engineering (WZL) of RWTH Aachen University':
    'Laboratory for Machine Tools and Production Engineering (WZL) of RWTH Aachen University',
  // LinkList.tsx
  Links: 'Links',
  // links.tx
  Source: 'Quellcode',
  // UserMenu.tsx
  Logout: 'Abmelden',
  'Logged in as: ': 'Angemeldet als: ',
  // Login.tsx
  Login: 'Einloggen',
  'Accounts are managed through Keycloak as OpenID Provider. Follow the link below to sign in.':
    'Benutzeraccounts werden mit Keycloak verwaltet. Bitte klicken Sie auf den untenstehenden Link zum anmelden.',
  'Virtual Machine Vision Lab': 'Virtual Machine Vision Lab',
  'Virtuelles Bildverarbeitungslabor zur Vorlesung "Optische Messtechnik und Bildverarbeitung".':
    'Virtuelles Bildverarbeitungslabor zur Vorlesung "Optische Messtechnik und Bildverarbeitung".',
  'Bei Fragen, konstruktiver Kritik oder allgemeinen Anmerkungen senden Sie bitte eine E-Mail an Matthias Bodenbenner.':
    'Bei Fragen, konstruktiver Kritik oder allgemeinen Anmerkungen senden Sie bitte eine E-Mail an Matthias Bodenbenner.',
  'E-Mail': 'E-Mail',
  'User Login': 'Anmeldung',
  'Logged in as': 'Eingeloggt als',
  'If you want to change the login token, please enter a different one and click "Login".': 'Wenn Sie das Login Token ändern möchten, geben Sie ein anderes ein und klicken Sie auf "Einloggen"',
  'Usertoken': 'Nutzungstoken',
  'I don\'t have a usertoken.': 'Ich habe kein Nutzungstoken',
  'Close': 'Schließen',
  'You are currently not logged in. To login, please enter your usertoken and click on "Login".': 'Sie sind aktuell nicht eingeloggt. Um sich einzuloggen, geben Sie bitte Ihr Nutzungstoken ein und klicken Sie anschließend auf "Einloggen".',
  'Not logged in': 'Nicht eingeloggt',
  'Generate new token': "Generierung eines neuen Token",
  'To use this site correctly you need a generated usertoken.': 'Um diese Website korrekt nutzen zu können, benötigen Sie einen generierten NutzungsToken.',
  'You will need to enter it on the previous dialog if you are logged out. (E.g. you are using this website from a different device or using a different browser)': 'Sie müssen den Token im vorherigen Dialogfeld eingeben, wenn Sie abgemeldet sind. (z. B. wenn Sie diese Webseite von einem anderen Gerät aus nutzen oder einen anderen Browser verwenden)',
  'If you do not have a token yet you can create a new one here.': 'Wenn Sie noch keinen Token haben, können Sie hier einen neuen Token erstellen.',
  'IMPORTANT: The token is NOT recoverable, if you lose it you will lose any progress associated with it. Make sure to save it locally or write it down.': 'WICHTIG: Der Token kann NICHT wiederhergestellt werden, wenn Sie ihn verlieren, verlieren Sie alle damit verbundenen Fortschritte. Speichern Sie den Token lokal oder schreiben Sie ihn auf.',
  'I am aware that this token cannot be recovered and have made a copy of it.': 'Mir ist bekannt, dass dieses Token nicht wiederhergestellt werden kann, und ich habe eine Kopie davon gemacht.',
  'Generate': "Generieren",
  'Copied to clipboard!': 'In die Zwischenablage kopiert!',
  'This token does not exist!': 'Dieses Token existiert nicht!',
  // DoubleParameter.tsx
  'real out of': 'real aus',
  // IntParameter.tsx
  'integer out of': 'ganzzahlig aus',
  // parameterValidatorService.ts
  'Invalid Input': 'Ungültige Eingabe',
  'Not a number': 'Keine Zahl',
  'Not an integer': 'Keine Ganzzahl',
  // AddEdgeDialog.tsx
  'Create Edge': 'Kante erstellen',
  // AddServiceDialog.tsx
  Parameter: 'Parameter',
  'Expected Inputs': 'Erwartete Inputs:',
  'Create Service': 'Service erstellen',
  // BottomNavigationBar.tsx
  'Center Edge': 'Verbindung zentrieren',
  'Edit Edge': 'Verbindung bearbeiten',
  'Remove Edge': 'Verbindung entfernen',
  'Add Edge': 'Verbindung hinzufügen',
  'Center Service': 'Service zentrieren',
  'Edit Service': 'Service bearbeiten',
  'Remove Service': 'Service entfernen',
  'Add Service': 'Service hinzufügen',
  'Error fetching services.': 'Fehler abfangende Services.',
  // ControlNavigationBar.tsx
  Run: 'Ausführen',
  Save: 'Speichern',
  // ServiceDrawer.tsx
  Services: 'Services',
  // ConfirmDialog.tsx
  Confirm: 'Sind Sie sicher?',
  // PipelineTable.tsx
  Delete: 'Löschen',
  // StartPage.tsx
  'Optische Messtechnik und Bildverarbeitung': 'Optische Messtechnik und Bildverarbeitung',
  Visionlab: 'Visionlab',
  'das virtuelle Bildverarbeitungslabor': 'das virtuelle Bildverarbeitungslabor',
  IntroductionOne:
    'Für die nachhaltige Erwerbung von Wissen ist Anwendung des theoretisch Erlernten von großer Bedeutung. Die händische Durchführung von Bildverarbeitungsalgorithmen ist jedoch nicht ohne erheblichen Aufwand möglich. Außerdem kann das Verhalten von Bildverarbeitungsalgorithmen so nicht anschaulich vermittelt werden. In den vergangenen Jahren haben wir zur Anwendung der Algorithmen Programmieraufgaben gestellt. Dabei haben wir jedoch die Erfahrung gemacht, dass diese nicht gut angenommen werden, auch da oftmals nicht ausreichend Programmierkenntnisse vorhanden sind.',
  IntroductionTwo:
    "Daher erproben wir eine neue selbstentwickelte Form der digitalen Lehre. Das Visionlab bietet Ihnen die Möglichkeit, das Verhalten von Bildverarbeitungsalgorithmen zu untersuchen und in der Vorlesung und Übung theoretisch erworbenes Wissen an einfachen Beispielen umzusetzen. Durch die Nutzung des Visionlab sind hierfür keinerlei Programmierkenntnisse erforderlich. Alles was Sie zur Bearbeitung der Aufgabenstellungen benötigen erlernen Sie in der Vorlesung und Übung. Des Weiteren gibt es für jeden Algorithmus eine Dokumentation mit Erläuterungen und Links zur weiterführender Literatur.",
  IntroductionThree:
    'Bei inhaltlichen Fragen oder technischen Problemen, wenden Sie sich Bitte an',
  // PipelineList.tsx
  'No pipelines found': 'Keine Pipelines gefunden',
  // AlgorithmTable.tsx
  'Module': 'Modul',
  'Parameters': 'Parameter',
  'ReturnValues': 'Rückgabewerte',
  // AlgorithmTable.tsx/Algorithm Translations; Algorithm names
  'Addieren': 'Addieren',
  'Dividieren': 'Dividieren',
  'Multiplizieren': 'Multiplizieren',
  'Subtrahieren': 'Subtrahieren',
  'Einzelbild': 'Einzelbild',
  'Spezialbild': 'Spezialbild',
  'Video': 'Video',
  'Gradient': 'Gradient',
  'Schärfen': 'Schärfen',
  'Glättung': 'Glättung',
  'Canny-Edge-Detektor': 'Canny-Edge-Detektor',
  'Connected Components': 'Connected Components',
  'Binarisieren': 'Binarisieren',
  'In RGB-Bild umwandeln': 'In RGB-Bild umwandeln',
  'Dilatation': 'Dilatation',
  'Erosion': 'Erosion',
  'Gammakorrektur': 'Gammakorrektur',
  'Bild in Graustufen konvertieren': 'Bild in Graustufen konvertieren',
  'Skalieren': 'Skalieren',
  // Algorithm Translations; Algorithm Modules
  'Grundoperationen': 'Grundoperationen',
  'Bildquellen': 'Bildquellen',
  'Filteroperationen': 'Filteroperationen',
  'Andere': 'Andere',
  'Pre-Processing': 'Pre-Processing',
  // Algorithm Translations; Algorithm Parameters
  'Datei': 'Datei',
  'Endlosschleife': 'Endlosschleife',
  'Maske': 'Maske',
  'Orientiereung': 'Orientierung',
  'Kernel Größe': 'Kernel Größe',
  'Filter': 'Filter',
  'Filtergröße': 'Filtergröße',
  'Randverhalten': 'Randverhalten',
  'Unterer Grenzwert': 'Unterer Grenzwert',
  'Oberer Grenzwert': 'Oberer Grenzwert',
  'Nachbarschaft': 'Nachbarschaft',
  'Threshold': 'Threshold', // Also Return Value
  'Gammafaktor': 'Gammafaktor',
  'Größe': 'Größe',
  'Achse': 'Achse',
  // AlgorithmDocumentation.tsx
  'Requested documentation not found!': 'Die angeforderte Dokumentation konnte nicht gefunden werden!',
  'An unexpected error occured!': 'Ein unerwarteter Fehler ist aufgetreten!',
  // tutorial.tsx
  'Abort Tutorial?': 'Tutorial abbrechen?',
  'Are you sure you want to end the tutorial? Your current tutorial progress will be lost. This does not include any created pipelines or generated results.':
    'Sind Sie sich sicher, dass sie das Tutorial abbrechen wollen? Jeglicher Fortschritt geht hierbei verloren. Erstellte Pipelines und generierte Ergebnisse bleiben jedoch erhalten.',
  // DemoBar.tsx
  DemoBanner:
    "Bei dieser Webseite handelt es sich um eine Beta Version zu Demonstrationszwecken. Sie befindet sich noch in aktiver Entwicklung!",
  'Add Edge or Service?': 'Kante oder Service hinzufügen?',
  // Assignment.tsx
  'Submission': 'Abgabe',
  'Submit': 'Abgeben',
  'Select Pipeline': 'Pipeline auswählen',
  // ServiceResult.tsx
  'Type': 'Typ',
  'Service List': 'Service Liste',
  // ConfirmDialog.tsx
  'Do you really want to irreversibly delete the selected pipelines?': 'Sind Sie sich sicher, dass Sie die ausgewählten Pipelines löschen wollen?',
  'Are you sure you want to irreversibly delete the selected results?': 'Sind Sie sich sicher, dass Sie die ausgewählten Ergebnisse löschen wollen?',
};

export default de;
